@if (organizationRegulations().length > 0) {
  <adm-step4-price-regulations-list
    [regulations]="organizationRegulations()"
    (editRegulation)="openEditRegulation($event)"
    (deleteRegulation)="deleteRegulation($event)"></adm-step4-price-regulations-list>
}
<adm-org-wizard-price-regulations-create
  [organization]="organization()"
  [regulationToEdit]="regulationToEdit()"
  (regulationCreated)="onRegulationCreated()"
  (regulationEditClosed)="onRegulationEditClosed()"></adm-org-wizard-price-regulations-create>

<button mat-raised-button class="margin--top-s" color="primary" (click)="skipStep.emit()">Tilknyt moduler</button>
